import { Container, Content, Background } from './styles';

export const AuthLayout: React.FC = ({ children }) => (
  <Container>
    <Content>
      {children}
    </Content>
    <Background />
  </Container>
);
